export const fr = {
  daterange: {
    on: 'Le {1}',
    to: '{1} à {2}',
    after: 'Après {1}',
    before: 'Avant {1}',
    today: "Aujourd'hui",
    yesterday: 'Hier',
    tomorrow: 'Demain',
    last: '{1} Dernier',
    next: '{1} Prochain',
  },
  pikaday: {
    today: 'Auj.',
    previousMonth: 'Mois Précédent',
    nextMonth: 'Mois Suivant',
    months: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ],
    weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  },
};
